import { HttpService } from 'core/modules/network-service';
import { get } from 'lodash';
import { SERVICE_RESPONSE_STATUS } from 'constants/common';
import { getVisibleItems } from 'resolvers/getVisibleEntities';

/*************************************************************/

/**
 * @type {class}
 * @desc CSrOrderListNotesWorkFlowLog defines an HTTP service interface to send HTTP network requets.
 * @example
 * import { CSrOrderListNotesWorkFlowLogService } from 'services/cSROrderListNotesWorkFlowLog';
 *
 * // create service instance and send/cancel request
 * const cSrOrderListNotesWorkFlowLogService = new CSrOrderListNotesWorkFlowLogService();
 * const result = await cSrOrderListNotesWorkFlowLogService.fetchData( '<user-id>' ); // fetch data
 * cSrOrderListNotesWorkFlowLogService.cancel(); // cancel an active request
 */
export class CSrOrderListNotesWorkFlowLogService extends HttpService {

    // make request and fetch data
    async fetchData( { url, data } ) {

        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data,
            } );

            const visibility = get( response, 'body.component.visibility', [] );
            const actions = get( response, 'body.component.structure.actions', [] );

            log.debug( actions, 'actions' );
            log.debug( visibility, 'visibility' );

            
            return {
                status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.ERROR ),
                data: {
                    ...get( response, 'body.component', [] ),
                    actions: getVisibleItems( actions, visibility )
                }
            };
        } catch( errResponse ) {
            return this._errorFormatter( errResponse );
        }
    }

    // format error response
    _errorFormatter( errResponse ) {
        return errResponse; // some logic
    }
}
